export default __webpack_public_path__ + "static/media/CNo.77-4.fb066941.jpg";